import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthLinksService } from './auth-links.service';
import { LoggerService } from './logger.service';
import { CLIENT_REDIRECT_AFTER_AUTH_ROUTES } from 'src/util/constants';
import { InAppBrowserAuthService } from './in-app-browser-auth.service';
import { DeviceService } from './device.service';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NavigateAfterLoginService {
  private loggerService = inject(LoggerService);
  private router = inject(Router);
  private authLinksService = inject(AuthLinksService);
  private inAppBrowserAuthService = inject(InAppBrowserAuthService);
  private deviceService = inject(DeviceService);
  private localStorageService = inject(LocalStorageService);

  public saveRouteAndAuth(afterAuthRoute: string): void {
    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN,
      value: afterAuthRoute,
    });

    this.forceLogin(afterAuthRoute);
  }

  private forceLogin(afterAuthRoute: string) {
    if (CLIENT_REDIRECT_AFTER_AUTH_ROUTES.some(term => afterAuthRoute.includes(term))) {
      if (this.deviceService.isNativePlatform) {
        this.inAppBrowserAuthService.openInAppBrowser();
      } else {
        window.location.href = this.authLinksService.bcasClientLoginUrl;
      }
    } else {
      throw new Error('Unknown login user for route: ' + afterAuthRoute);
    }
  }

  public checkRedirectAndReloadIfExist(afterAuthRoute: string): void {
    if (this.deviceService.isNativePlatform) {
      this.loggerService.error('Routing after logout is not supported for native apps!');
    } else {
      if (afterAuthRoute) {
        this.router.navigateByUrl(afterAuthRoute);
        this.localStorageService.deleteItem({ key: LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN });
      }
    }
  }
}
